import { render } from "./PledgeOrderView.vue?vue&type=template&id=ed6d8030"
import script from "./PledgeOrderView.vue?vue&type=script&lang=js"
export * from "./PledgeOrderView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__